import { Component, OnInit, Input, Inject, LOCALE_ID } from '@angular/core';
import { httpservice, Message } from 'src/app/commons/commons.module';
import { MatTableDataSource } from '@angular/material/table';
import { formatDate } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDatepickerIntl } from '@angular/material/datepicker';

@Component({
  selector: 'otvoreni-racuni-id',
  templateUrl: 'otvoreni-racuni-id.component.html',
  styleUrls: ['otvoreni-racuni-id.component.css']
})

export class OtvoreniRacuniIDComponent implements OnInit {
  getservice: httpservice;
  @Input() korisnik?: "";
  @Input() vrstausluge?: "";
  displayedColumns: string[] = ['datum', 'isprava', 'redniBroj', 'racun','datumRacuna','valutaRacuna', 'duguje','potrazuje','saldo','status'];
  lista: any;
  duguje: number;
  potrazuje: number;
  saldo: number;
  oddana: Date;
  dodana: Date;
  iskljucipocetno: boolean;
  konto: string;
  uporabakonta: boolean;

  constructor(dataservice: httpservice, @Inject(LOCALE_ID) private locale: string, private _snackBar: MatSnackBar)
  {
    this.getservice = dataservice;
   
  }

  ngOnInit() {
    
    this.duguje = 0;
    this.potrazuje = 0;
    this.saldo = 0;
    this.dodana = new Date();
    this.oddana = new Date(this.dodana.getFullYear(), 0, 1);
    this.konto = "";
    this.iskljucipocetno = false;
    this.uporabakonta = false;
    this.UcitajRacune();
    

  }


  UcitajRacune() {
    try {
      this.getservice.GetRequest<Message>("komunalno/saldakonti/kartica/OtvoreniRacuniPoIDu?korisnik=" + this.korisnik + "&vrstaUsluge=" + this.vrstausluge + "&oddana=" + formatDate(this.oddana, "yyyy-MM-dd", this.locale) + "&dodana=" + formatDate(this.dodana, "yyyy-MM-dd", this.locale)).subscribe(result => {
        if (result.status === "success") {
          this.lista = result.data;
          this.duguje = 0;
          this.potrazuje = 0;
          this.saldo = 0;
          this.lista.forEach((element) => {
            this.duguje += element.duguje;
            this.potrazuje += element.potrazuje;
            this.saldo += element.saldo;
          })
        }
      }, error => console.error('Get otvoreni računi', error));
    }
    catch (error) {
      console.error('Log error', error);
    }
  }

  Ispis() {    
    this.getservice.GetRequestFile<Blob>("komunalno/saldakonti/kartica/otvoreniRacuniPoIDuPdf?korisnik=" + this.korisnik + "&vrstaUsluge=" + this.vrstausluge).subscribe((data: Blob) => {
        var file = new Blob([data], { type: 'application/pdf' })
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }, (error) => {
        console.log('getPDF error: ', error);
      });    
  }

  IspisIos() {
    this.getservice.GetRequestFile<Blob>("komunalno/saldakonti/kartica/IosPoIDuPdf?korisnik=" + this.korisnik + "&vrstaUsluge=" + this.vrstausluge + "&oddana=" + formatDate(this.oddana, "yyyy-MM-dd", this.locale) + "&dodana=" + formatDate(this.dodana, "yyyy-MM-dd", this.locale)).subscribe((data: Blob) => {
      var file = new Blob([data], { type: 'application/pdf' })
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }, (error) => {
      console.log('getPDF error: ', error);
    });
  }

  ZatvoriRacune() {
    this.getservice.GetRequest<Message>("komunalno/saldakonti/ZatvaranjeRacuna/zatvori?korisnik=" + this.korisnik + "&iskljucipocetno="+this.iskljucipocetno+"&konto="+this.konto+"&vrstaUsluge=" + this.vrstausluge).subscribe(result => {
      if (result.status === "success") {
        this.UcitajRacune();
        this.Poruka("Završeno zatvaranje računa", "Uredu");
      }
      else {
        this.Poruka("greška " + result.data, "Uredu");
      }
    }, error => { this.Poruka("greška " + error, "Uredu"); });

  }

  Poruka(message: string, action: string) {
    this._snackBar.open(message, action);
  }
}



